import { createFileRoute, redirect } from "@tanstack/react-router";
import { withQuery } from "@/lib/redirect-query";

/** Legacy /locations/nyc/ now lives at the New York state hub. */
export const Route = createFileRoute("/locations/nyc")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: withQuery("/locations/new-york/", location.searchStr), statusCode: 301 });
  },
});
